import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[ssAutoFocus]'
})
/**
 * Allows for a dynamic autofocus on an element that might not exist yet.
 * E.g., the question-display component where multiple inputs are defined,
 * and multiple are shown simultaneously, but only one can receive focus.
 */
export class AutoFocusDirective implements AfterContentInit {

    public constructor(private el: ElementRef) { }

    ngAfterContentInit() {
        if (this.el)
            this.el.nativeElement.focus();
    }
}
